<template>
  <section>
    <h3 class="primary--text">{{ message }}</h3>
  </section>
</template>

<script>
export default {
  name: "BookmarkActivity",
  props: ["eventDateObj", "message"]
}
</script>
